// The site-wide notice an admin sets from the console (docs/admin/actions.md,
// "Site-wide notice"): one plain line that everyone sees, signed in or not.
// Read from the public GET /api/site-notice when the app opens and every five
// minutes while the tab is in view; the server answers from memory and lets
// the browser keep the answer 30 seconds.
import React, { useEffect, useState } from 'react';
import { API_BASE, fetchWithTimeout } from '../apiSession';
import './SiteNotice.css';

const ASK_EVERY = 5 * 60_000;

export function useSiteNotice() {
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    let live = true;
    const ask = async () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      try {
        const res = await fetchWithTimeout(`${API_BASE}/api/site-notice`, {}, 8000);
        const body = await res.json().catch(() => null);
        if (!live || !res.ok) return;
        const n = body?.notice;
        const text = n && typeof n.text === 'string' ? n.text.trim() : '';
        setNotice(text ? { text, level: n.level === 'warning' ? 'warning' : 'info' } : null);
      } catch {
        // A notice is a courtesy: no answer means no notice.
      }
    };
    ask();
    const id = setInterval(ask, ASK_EVERY);
    return () => { live = false; clearInterval(id); };
  }, []);
  return notice;
}

export default function SiteNotice() {
  const notice = useSiteNotice();
  // The text the person closed: a new notice shows again.
  const [closed, setClosed] = useState(null);
  if (!notice || closed === notice.text) return null;
  return (
    <div className={`site-notice ${notice.level}`} role="status">
      <span className="material-symbols-rounded site-notice-icon" aria-hidden="true">
        {notice.level === 'warning' ? 'warning' : 'campaign'}
      </span>
      <span className="site-notice-text">{notice.text}</span>
      <button type="button" className="site-notice-close" onClick={() => setClosed(notice.text)} aria-label="Hide this notice">
        <span className="material-symbols-rounded" aria-hidden="true">close</span>
      </button>
    </div>
  );
}
